var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthStatus } from '@lean-body/src/interfaces';
import { CAMPAIGN_CODE_QUERY, COLLABORATION_CODE_QUERY } from '@lean-body/src/domain/campaign';
import { Subject } from 'rxjs';
import * as routes from './routes';
import { FBPixelEventName, LocalStorage, SessionStorage, SessionStorageType } from '@lean-body/src/infra';
import * as msg from '@lean-body/src/messages';
import * as alertGroup from '@lean-body/src/constants/alert_groups';
import { SettingItemKeys } from '../view/organisms/setting_menu';
export class RouteController {
    constructor(domainFactory, alertPresenter, config) {
        Object.defineProperty(this, "navigate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curLocation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "accountService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signedCookieService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alertPresenter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "outboundSbj", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Subject()
        });
        Object.defineProperty(this, "locationChangeSbj", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Subject()
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "redirectHandled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sessionStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signedCookieService = domainFactory.SignedCookieService();
        this.alertPresenter = alertPresenter;
        this.config = config;
        this.localStorage = new LocalStorage();
        this.sessionStorage = new SessionStorage();
        this.bindEvents();
    }
    initialize(domainFactory, location) {
        this.navigate = domainFactory.navigate;
        this.curLocation = location;
        this.accountService = domainFactory.AccountService();
        this.setParamsFromLPToLocalStorage();
    }
    /**
     * ページが切り替わった後の処理
     * リダイレクト判定をしてリダイレクト後にトラッキング・タグ埋めなどを行う。
     * @param location
     */
    onLocationChanged(location, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            window.scrollTo(0, 0);
            this.curLocation = location;
            this.handleSetParams(location.search);
            yield this.handleRedirect();
            // 強制redirect対象だったらフラグだけ変えて何もしない
            if (this.redirectHandled) {
                this.redirectHandled = false;
                return null;
            }
            tracker.trackPixelEvent(FBPixelEventName.PAGE_VIEW);
            this.locationChangeSbj.next(location.pathname);
            tracker.trackView();
        });
    }
    /**
     * 意図してないページ遷移した場合、リダイレクト判定を行う
     */
    handleRedirect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.matchRouteGroup(routes.NOT_HANDLE_REDIRECT_GROUP))
                return;
            // 協業用認証コード付きの新規登録URLでは、二重登録を避けるため SignUpV2Page 側で強制ログアウトする
            // そのため authStatus に応じた自動リダイレクトは行わない
            if (this.isCollaborationSignupWithCode())
                return;
            switch (this.accountService.authStatus) {
                case AuthStatus.Unauth:
                    // 末認証の場合
                    /**
                     * 認証必要ルートにいた場合、ログインページに飛ばす。eg) 未認証でTOPページにアクセス -> signinページに飛ばされる
                     */
                    if (this.isAtRestrictedLoaction) {
                        return this.redirect(routes.SIGNIN);
                    }
                    break;
                case AuthStatus.Authed:
                    // 認証していた場合
                    if (this.isAtAuthLocation ||
                        this.matchRouteGroup(routes.FUTURE_USER_PAGE) ||
                        this.matchRouteGroup(routes.SELECT_PAGE)) {
                        this.redirect(routes.TOP);
                    }
                    break;
                case AuthStatus.Dormant:
                    // 休眠会員状態かつ、休眠会員じゃないとアクセスできないルート以外のページにいたら、アカウントページに飛ばす
                    if (!this.matchRouteGroup(routes.DORMANT_ALLOWED_ROUTE_GROUP)) {
                        this.redirect(routes.SETTING, new URLSearchParams(`key=${SettingItemKeys.plan}`));
                    }
                    break;
                case AuthStatus.Future:
                    if (!this.matchRouteGroup(routes.FUTURE_USER_PAGE)) {
                        this.redirect(routes.FUTURE_USER);
                    }
                    break;
                case AuthStatus.NoSubscription:
                    if (!this.matchRouteGroup(routes.SELECT_PAGE)) {
                        this.redirectToCCRegistration();
                    }
            }
        });
    }
    /**
     * 各種ASPタグ埋め込み、またはお友だち紹介成約の時に使うパラメータをURLから取得
     * @param searchParams
     */
    handleSetParams(searchParams) {
        const params = searchParams.substring(1).split('&');
        params.map((param) => {
            const kv = param.split('=');
            switch (kv[0]) {
                case 'clid':
                    this.localStorage.saveStats({ insightClid: kv[1] });
                    break;
                case 'rtsp':
                    this.localStorage.saveStats({ rentracksVisitId: kv[1] });
                    break;
                case 'nta':
                    this.localStorage.saveStats({ ntaId: kv[1] });
                    break;
            }
        });
    }
    /**
     * LBで定義したrouteにpush
     * @param route
     * @param params
     */
    push(route, params) {
        this.navigate(route.compile(params));
    }
    /**
     * 任意の自由パスにpush
     * @param path
     */
    historyPush(path) {
        this.navigate(path);
    }
    redirectToCCRegistration() {
        // SignUpしたあとにブラウザを変えたりするとキャンペーンコード等がリダイレクト時に消えてしまうので、クレカ登録画面へのリダイレクトURLにはキャンペーンコードのパラメータを付与するようにしています。
        const urlSearchParams = new URLSearchParams();
        const campaignCode = this.getQueryParams().get(CAMPAIGN_CODE_QUERY);
        if (campaignCode) {
            urlSearchParams.append(CAMPAIGN_CODE_QUERY, campaignCode);
        }
        const invitationCode = this.getQueryParams().get('invitation_code');
        if (invitationCode) {
            urlSearchParams.append('invitation_code', invitationCode);
        }
        const collaborationCode = this.getQueryParams().get(COLLABORATION_CODE_QUERY);
        if (collaborationCode) {
            urlSearchParams.append(COLLABORATION_CODE_QUERY, collaborationCode);
        }
        const redirectRoute = this.localStorage.loadIsBulkRegistration ? routes.SIGNUP_V2 : routes.CC_REGISTRATION;
        this.redirect(redirectRoute, urlSearchParams);
    }
    /**
     * urlクエリパラメータの取得
     */
    getQueryParams() {
        return new URLSearchParams(this.curLocation.search);
    }
    get locationChange$() {
        return this.locationChangeSbj;
    }
    get outbound$() {
        return this.outboundSbj;
    }
    // 要認証locationにいるか
    get isAtRestrictedLoaction() {
        return !this.isAtUnRestrictedLocation;
    }
    // 認証不要のlocationにいるか
    get isAtUnRestrictedLocation() {
        return this.matchRouteGroup(routes.UNRESTRICTED_ROUTE_GROUP);
    }
    // 認証画面locationにいるか
    get isAtAuthLocation() {
        return this.matchRouteGroup(routes.AUTH_ROUTE_GROUP);
    }
    authorizationForSignin() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authorizationWithForbiddenRedirect()
                .then(() => {
                const redirectParams = this.sessionStorage.loadSigninRedirect();
                if (redirectParams) {
                    this.sessionStorage.remove(SessionStorageType.SigninRedirect);
                    this.historyPush(redirectParams);
                }
                else
                    [this.redirect(routes.TOP)];
            })
                .catch((e) => {
                if (!e.isForbiddenError)
                    throw e;
            });
        });
    }
    // authorizationでエラーの場合のみリダイレクト
    authorizationWithForbiddenRedirect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.accountService
                .authorization()
                .then((data) => {
                this.signedCookieService.fetchSignedCookies(); // 動画を閲覧するための署名付きCookie取得
                return data;
            })
                .catch((e) => {
                // ログイン後にFutureユーザーやDormantユーザーはForbiddenErrorになるはokなので、他を例外にする
                if (e.isForbiddenError) {
                    const forbiddenError = e;
                    if (forbiddenError.isPaymentNotFound) {
                        if (!this.matchRouteGroup(routes.SELECT_PAGE)) {
                            this.alertPresenter.showMessage(msg.PLAN_UNREGISTERED);
                            this.redirectToCCRegistration();
                        }
                    }
                    else if (forbiddenError.isPaymentExpired) {
                        if (!this.matchRouteGroup(routes.SELECT_PAGE)) {
                            this.alertPresenter.showMessage(msg.ACCOUNT_EXPIRED, alertGroup.ACCOUNT_EXPIRED);
                            this.redirectToCCRegistration();
                        }
                    }
                    else if (forbiddenError.isDormant) {
                        this.alertPresenter.showMessage(msg.ALREADY_DORMANT, 'account_already_activated');
                        this.historyPush(`${routes.SETTING.compile()}?key=${SettingItemKeys.plan}`);
                    }
                    else if (forbiddenError.isFuture) {
                        this.push(routes.FUTURE_USER);
                    }
                }
                throw e;
            });
        });
    }
    /**
     * private methods
     */
    redirect(route, params) {
        this.redirectHandled = true;
        if (params) {
            this.historyPush(`${route.compile()}?${params.toString()}`);
        }
        else {
            this.push(route);
        }
    }
    isAtRoute(route) {
        return route.matchPath(this.curLocation.pathname);
    }
    matchRouteGroup(group) {
        return group.matchPath(this.curLocation.pathname);
    }
    bindEvents() {
        window.onbeforeunload = () => {
            this.outboundSbj.next();
        };
    }
    setParamsFromLPToLocalStorage() {
        if (!this.isAtRoute(routes.SIGNIN) &&
            !this.isAtRoute(routes.SIGNUP) &&
            !this.isAtRoute(routes.CC_REGISTRATION) &&
            !this.isAtRoute(routes.SIGNUP_V2) &&
            !this.isAtRoute(routes.SIGNUP_MATCHING_ASSESSMENT) &&
            !this.isAtRoute(routes.CALLBACK_AMAZON_PAY_FOR_SIGNUP))
            return;
        const campaignCode = this.getQueryParams().get(CAMPAIGN_CODE_QUERY);
        this.localStorage.saveCampaingCode(campaignCode);
        const invitationCode = this.getQueryParams().get('invitation_code');
        this.localStorage.saveInvitationCode(invitationCode);
        const courseCode = this.getQueryParams().get('course_code');
        this.localStorage.saveCourseCode(courseCode);
        if (this.isAtRoute(routes.CALLBACK_AMAZON_PAY_FOR_SIGNUP) &&
            this.getQueryParams().get('is_from_lp_payment_form') === '1') {
            this.sessionStorage.saveIsFromLpPaymentForm(true);
        }
    }
    /** 協業用認証コード付きの新規登録画面（/signup_v2?collaboration_code=...）か */
    isCollaborationSignupWithCode() {
        return this.isAtRoute(routes.SIGNUP_V2) && !!this.getQueryParams().get(COLLABORATION_CODE_QUERY);
    }
}
